import React from 'react';
import './CompanyPage.css';

import { PageTitle } from '../../../components';
import { WhyUs, Banner, Process, Skills, FAQs, Clients, History } from '../../../sections';



const CompanyPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Company History'} page={'Company History'} />

      <section className='company-page'>

        <History />
        <WhyUs />
        <Process />
        <Skills />
        <FAQs />
        <Banner />
        <Clients />

      </section>

    </>
  );
}

export default CompanyPage;